import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { nanoid } from 'nanoid'
import { ToastVariant } from '../../components/Toast/Toast'

interface ToastWithId {
  id: string
  variant?: ToastVariant
  title?: string
  delay?: number
  messages?: string[]
}

interface ToastState {
  toasts: ToastWithId[]
}

const initialState: ToastState = {
  toasts: [],
}
export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    addToast: (state, { payload }) => {
      const isDuplicate = state.toasts.some(
        (toast) => toast.title === payload.title && JSON.stringify(toast.messages) === JSON.stringify(payload.messages) && toast.variant === payload.variant,
      )
      if (!isDuplicate) {
        state.toasts = [...state.toasts, { id: nanoid(), variant: payload.variant, title: payload.title, messages: payload.messages, delay: payload.delay }]
      }
    },
    removeToast: (state, { payload }) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== payload)
    },
  },
})

export const { addToast, removeToast } = toastSlice.actions

export const selectToasts = (state: RootState) => state.toast.toasts

export default toastSlice.reducer
